import { Button, makeStyles, Theme } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import clsx from "clsx";
import React, { MouseEventHandler } from "react";

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    marginLeft: theme.spacing(-0.5),
    padding: theme.spacing(0.5),
    paddingRight: theme.spacing(1),
    textTransform: "capitalize",
    backgroundColor: "rgba(38, 50, 56, 0.08)",

    "& svg, & path": {
      fill: "#3F51B5",
    },

    "&:hover": {
      backgroundColor: "rgba(38, 50, 56, 0.2)",
    },
  },
}));

export type AddValueButtonProps = {
  fieldName: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  overrideStyles?: React.CSSProperties;
};

export default function AddValueButton({
  fieldName,
  onClick,
  overrideStyles = undefined,
}: AddValueButtonProps) {
  return (
    <CTAButton
      text={"Add " + fieldName}
      onClick={onClick}
      overrideStyles={overrideStyles}
    />
  );
}

export type CTAButtonProps = {
  text: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  overrideStyles?: React.CSSProperties;
};

export function CTAButton({
  text,
  onClick,
  overrideStyles = undefined,
}: CTAButtonProps) {
  const classes = useStyles();

  return (
    <Button
      className={clsx(classes.button)}
      onClick={onClick}
      style={overrideStyles}
    >
      <Add /> {text}
    </Button>
  );
}
